import { Spin, Table } from "antd";
import React from "react";
import { ICashTransferClient } from "../../types/cashTransferClient.type";
import { roundToThreeDecimals } from "../../utils/roundToThreeDecimals";

interface CashTransferStatsProps {
  data: ICashTransferClient[];
  loading: boolean;
}

export default function CashTransferStats({
  data,
  loading,
}: CashTransferStatsProps) {
  if (loading) {
    return <Spin size="large" />;
  }

  if (!data) {
    return <div>No data available</div>;
  }

  const columns = [
    {
      title: "Имя",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Долг клиента в USD",
      key: "clientDebtUSD",
      render: (_: any, client: ICashTransferClient) =>
        roundToThreeDecimals(client.totalClientDebt.USD),
    },
    {
      title: "Долг клиента в TJS",
      key: "clientDebtUSD",
      render: (_: any, client: ICashTransferClient) =>
        roundToThreeDecimals(client.totalClientDebt.TJS),
    },
  ];

  return (
    <div style={{ padding: 20 }}>
      <h2 style={{ textAlign: "center" }}>
        Статистика по Клиентам Конвертации
      </h2>
      <div style={{ marginTop: "20px", maxHeight: "300px", overflowY: "auto" }}>
        <Table
          dataSource={data}
          columns={columns}
          rowKey={(record) => record._id}
          pagination={false}
          scroll={{ y: 240 }}
          rowClassName="row-red"
        />
      </div>
    </div>
  );
}
